import { FC, memo } from 'react';

import { BlockComponent } from '../../Block';
import { ContentProps } from './types/ContentProps';

const ContentComponent: FC<ContentProps> = ({ block }) => (
  <>
    {block.content.map((contentBlock) => (
      <BlockComponent key={contentBlock.id} block={contentBlock} />
    ))}
  </>
);

export const Content = memo(ContentComponent);
